export class UpdateNetworkCommandResponse
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here
        }
    }

    Message: string;
    Success: boolean;
}
